export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-300/50">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-line text-foreground-50 text-lg"></i>
              </div>
              <span className="text-foreground-50 font-bold text-base font-heading">每日大赛黑料</span>
            </div>
            <p className="text-foreground-500 text-sm leading-relaxed">
              每日大赛黑料网，专注大赛黑料爆料与黑料吃瓜，提供每日黑料最新动态，深度揭秘大赛内幕，汇聚黑料揭秘与深度爆料，今日吃瓜黑料每日爆料最新。
            </p>
          </div>

          <div>
            <h4 className="text-foreground-200 font-semibold text-sm mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '最新快讯', href: '#updates' },
                { label: '专题合集', href: '#index' },
                { label: '焦点爆料', href: '#carousel' },
                { label: '深度揭秘', href: '#cards' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-foreground-500 hover:text-primary-400 text-sm transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-foreground-200 font-semibold text-sm mb-4">关于我们</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '平台介绍', href: '#about' },
                { label: '投稿爆料', href: '#contact' },
                { label: '常见问答', href: '#faq' },
                { label: '移动客户端', href: '#app' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-foreground-500 hover:text-primary-400 text-sm transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-foreground-200 font-semibold text-sm mb-4">合作伙伴</h4>
            <p className="text-foreground-600 text-sm leading-relaxed">
              合作伙伴信息持续更新中，欢迎优质品牌与平台洽谈合作。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-600 text-xs">
            &copy; {currentYear} 每日大赛黑料网 · 版权所有
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-foreground-600 hover:text-foreground-300 text-xs transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-foreground-600 hover:text-foreground-300 text-xs transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-foreground-600 hover:text-foreground-300 text-xs transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}